import React from 'react';
import { ContextType, ProviderTypes } from './types';

export const PurchaseReturnContext = React.createContext<ContextType>({} as ContextType);

export const PurchaseReturnProvider: React.FC<ProviderTypes> = (props) => {
  // Reset Modal
  const [reset, setReset] = React.useState(false);
  const resetState = {
    isOpen: reset,
    open: () => setReset(true),
    close: () => setReset(false),
  };

  // Submit Modal
  const [submit, setSubmit] = React.useState(false);
  const submitState = {
    isOpen: submit,
    open: () => setSubmit(true),
    close: () => setSubmit(false),
  };

  // Search Product Table Modal
  const [productInputAnchorEl, setProductInputAnchorEl] = React.useState<HTMLInputElement | null>(
    null,
  );
  const productState = {
    anchorEl: productInputAnchorEl,
    open: (element: HTMLInputElement | HTMLTextAreaElement | null) =>
      setProductInputAnchorEl(element as HTMLInputElement),
    close: () => setProductInputAnchorEl(null),
  };

  return (
    <PurchaseReturnContext.Provider
      value={{
        reset: resetState,
        submit: submitState,
        productField: productState,
      }}
    >
      {props.children}
    </PurchaseReturnContext.Provider>
  );
};
